import { render } from "./ImportInstruction.vue?vue&type=template&id=954ec6fa&scoped=true"
import script from "./ImportInstruction.vue?vue&type=script&lang=js"
export * from "./ImportInstruction.vue?vue&type=script&lang=js"

import "./ImportInstruction.vue?vue&type=style&index=0&id=954ec6fa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954ec6fa"]])

export default __exports__